export const API_RECOMMENDED_ALGOS_SUCCESS = "API_RECOMMENDED_ALGOS_SUCCESS";
export const API_RECOMMENDED_ALGOS_FAIL = "API_RECOMMENDED_ALGOS_FAIL";
export const GET_RECOMMENDED_ALGOS = "GET_RECOMMENDED_ALGOS";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
